<template>
  <div class="app-main-content intelligent-booking">
    <div class="tabs-container">
      <el-tabs v-model="activeTabName" type="card" style="width:100%">
        <el-tab-pane :lazy="true" :label="$t('CargoMsg.Cargo_PendingProvision')" name="pendingProvision" style="width:100%;height: 100%">
          <pending-provision ref="pendingProvision" :tab-title="$t('CargoMsg.Cargo_PendingProvision')" />
        </el-tab-pane>
        <el-tab-pane :lazy="true" :label="$t('CargoMsg.Cargo_ProvisionHistory')" name="provisionHistory" style="width:100%;height: 100%">
          <provision-history ref="provisionHistory" :tab-title="$t('CargoMsg.Cargo_ProvisionHistory')" />
        </el-tab-pane>
      </el-tabs>
    </div>

  </div>
</template>

<script>

import PendingProvision from '@/views/cargo/v0/Performance/tabPane/pendingProvision.vue'
import ProvisionHistory from '@/views/cargo/v0/Performance/tabPane/provisionHistory.vue'

export default {
  name: 'ProvisionReport',
  components: { ProvisionHistory, PendingProvision },
  data() {
    return {
      activeTabName: 'pendingProvision'
    }
  },
  activated() {},
  async created() {
  },
  methods: {

  }
}
</script>

<style scoped>

</style>
